var _path, _path2, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShoppingCart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.3818 14H8.7638L7.1268 8H19.3818L16.3818 14ZM21.0828 6.948C20.7158 6.354 20.0798 6 19.3818 6H6.5818L5.9648 3.737C5.8458 3.302 5.4508 3 4.9998 3H2.9998C2.4468 3 1.9998 3.448 1.9998 4C1.9998 4.552 2.4468 5 2.9998 5H4.2358L7.0348 15.263C7.1538 15.698 7.5488 16 7.9998 16H16.9998C17.3788 16 17.7248 15.786 17.8948 15.447L21.1708 8.894C21.4838 8.269 21.4498 7.542 21.0828 6.948ZM7.5 18C6.672 18 6 18.671 6 19.5C6 20.329 6.672 21 7.5 21C8.328 21 9 20.329 9 19.5C9 18.671 8.328 18 7.5 18ZM16 19.5C16 18.671 16.672 18 17.5 18C18.328 18 19 18.671 19 19.5C19 20.329 18.328 21 17.5 21C16.672 21 16 20.329 16 19.5Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_5_4794",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: 3,
    width: 21,
    height: 18
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.3818 14H8.7638L7.1268 8H19.3818L16.3818 14ZM21.0828 6.948C20.7158 6.354 20.0798 6 19.3818 6H6.5818L5.9648 3.737C5.8458 3.302 5.4508 3 4.9998 3H2.9998C2.4468 3 1.9998 3.448 1.9998 4C1.9998 4.552 2.4468 5 2.9998 5H4.2358L7.0348 15.263C7.1538 15.698 7.5488 16 7.9998 16H16.9998C17.3788 16 17.7248 15.786 17.8948 15.447L21.1708 8.894C21.4838 8.269 21.4498 7.542 21.0828 6.948ZM7.5 18C6.672 18 6 18.671 6 19.5C6 20.329 6.672 21 7.5 21C8.328 21 9 20.329 9 19.5C9 18.671 8.328 18 7.5 18ZM16 19.5C16 18.671 16.672 18 17.5 18C18.328 18 19 18.671 19 19.5C19 20.329 18.328 21 17.5 21C16.672 21 16 20.329 16 19.5Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_5_4794)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShoppingCart);
export default __webpack_public_path__ + "static/media/shopping-cart.a1e098009913c6bd59af2ca9056b376f.svg";
export { ForwardRef as ReactComponent };